import * as Sentry from '@sentry/react';
import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { contextGraphsKey } from '@/hooks/queries/use-context-graphs';
import {
  CreateContextGraphInput,
  createContextGraph,
} from '@/services/context-graphs/create-context-graph';
import { useOrgStore } from '@/stores/org-store';
import { ContextGraph } from '@/types/context-graph-types';

export const useCreateContextGraph = (
  options?: Omit<
    UseMutationOptions<ContextGraph, Error, CreateContextGraphInput>,
    'mutationFn'
  >,
) => {
  const queryClient = useQueryClient();
  const orgId = useOrgStore((state) => state.currentOrg?.orgid ?? null);

  return useMutation({
    ...options,
    mutationFn: createContextGraph,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: contextGraphsKey(orgId) });
      options?.onSuccess?.(data, variables, context, mutation);
    },
    onError: (error, variables, context, mutation) => {
      Sentry.captureException(error, {
        extra: { context: 'create-context-graph', name: variables.name },
      });
      options?.onError?.(error, variables, context, mutation);
    },
  });
};
